import React, { useMemo } from "react";

import { Parse, useParseQueryFirst } from "@openinc/parse-hooks";
import {
  AdminLayout,
  Loading,
  useSource,
  usePermission,
  LinkedSourcePicker,
  useTranslation,
} from "@opendash/core";

import GreisOperatingHoursSelect from "./GreisOperatingHoursSelect";
import { Divider } from "antd";

const OperatingService = "HG_Runtime";

export default function GreisOperating() {
  const [source] = useSource();
  const t = useTranslation();
  const serviceQuery = useMemo(
    () =>
      source?.tag
        ? new Parse.Query(OperatingService)
            .equalTo("spsid", source.tag)
            .limit(1000000)
        : null,
    [source]
  );

  const parseUser = Parse.User.current();
  const parseUserItem = parseUser;
  const serviceConfig = useParseQueryFirst(serviceQuery);
  const isAdmin = usePermission("hg:service-view");

  if (serviceConfig.loading) {
    return <Loading message="" />;
  }

  return (
    <GreisOperatingHoursSelect
      spsid={source ? source.tag : ""}
      admin={isAdmin}
      config={serviceConfig}
      user={parseUserItem}
      name={source ? source.name : ""}
    />
  );
}
